import { Expose, Type } from "class-transformer";
import { SignaturePlacementDto } from "@/core/features/employee-document-categories/signature-placement.dto";

export class UpsertSignaturePlacementsDto {
  @Expose()
  @Type(() => SignaturePlacementDto)
  placements: SignaturePlacementDto[];
}
